import React, {useEffect, useState} from "react";
import {Button, Col, Image, Input, message, Modal, Row, Space, Table} from "antd";
import { Card ,Drawer} from 'antd';
import {getHostAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies"
import {ExperimentButton} from "./ExperimentButton";
import {ExperimentButtonAndJump} from "./ExperimentButtonAndJump";
import {ExperimentDriwer} from "./ExperimentDriwer";
import Player from "griffith"
import {getFrontEndAddress,getFileAddress} from "../../Tool/UtileFun"
import { Typography } from 'antd';




export function ExperimentIMG(){

    useEffect(
        ()=>{
            findExperimentAll()
            console.log("classId:"+cookie.load(classId))
        },[]
    );

    const { Title } = Typography;
    const classId = "classID"
    const { Meta } = Card;
    const { Search } = Input;
    const [cardData,setCardData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [modalStatus,setModalStatus] = useState(false);
    const [experiment,setExperiment] = useState([]);

    const showModal = e =>{
        setModalStatus(true)
    }

    const handleOk = e =>{
        setModalStatus(false)
    }

    const handleCancel = e =>{
        setModalStatus(false)
    }

    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    const findExperimentAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findByUserCLassId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load(classId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCardData(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchExperiment=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findByName",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value,classId:cookie.load(classId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCardData(data)
            })
            .catch(error => message.error("error"+error));
    }



    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '名称',
            dataIndex: 'target',
            key: 'target',
        },
        {
            title: '操作',
            key: 'details',
            render: (experimentInfo) => (
                <>
                    <Space size="middle">
                        {/*<ExperimentButtonAndJump props={experimentInfo}></ExperimentButtonAndJump>*/}
                        <ExperimentDriwer props={experimentInfo}></ExperimentDriwer>
                    </Space>
                </>
            ),
        },

    ];

    const experimentID = "experimentID"
    const experimentInfo = value =>{
        cookie.save(experimentID,value.id)
        window.open("http://"+getFrontEndAddress()+"/user/video")
    }

    const imgData = (
        <div>
            {/*<Row>*/}
            {/*    <Col span={6} >*/}

            {/*    </Col>*/}
            {/*    <Col span={1} >*/}

            {/*    </Col>*/}
            {/*    <Col span={12} >*/}
            {/*        <Title level={3}>RPA审计机器人课程平台</Title>*/}
            {/*    </Col>*/}
            {/*    <Col span={6} >*/}

            {/*    </Col>*/}
            {/*</Row>*/}
        <Row gutter={[24,24]}>
            {
                cardData.map(
                    card=>
                        <Col>
                            <Card
                                hoverable
                                style={{ width: 250}}
                                onClick={()=>experimentInfo(card)}
                                cover={<img style={ {height : 180}}
                                            alt={card.target}
                                            src={"http://"+getFrontEndAddress()+card.relativeAddress} />}
                            >
                                {/*description="共2节"*/}
                                <Meta title={card.target} />
                            </Card>
                        </Col>
                )
            }
        </Row>
        </div>
    )

    const sources = {
        hd: {
            play_url: "http://"+getFileAddress()+"/experimentResources/knowledgeLibrary/Java.flv",
        },
        sd: {
            play_url: "http://"+getFileAddress()+"/experimentResources/knowledgeLibrary/Java.flv",
        },
    }



    return(
        <>
            <Drawer
                title="实验详情"
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
            >
                <p>xxxxx</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
            </Drawer>

            <Modal
                title="Basic Modal"
                visible={modalStatus}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
            </Modal>
            {/*<Card title={"实验任务"}>*/}
            {/*    <Search placeholder="输入名称搜索"*/}
            {/*            onSearch={value => searchExperiment(value)}*/}
            {/*            enterButton*/}
            {/*            style={{width:500}}/>*/}
            {/*    <Table columns={columns} dataSource={cardData}></Table>*/}
            {/*</Card>*/}
            {imgData}
            {/*<Playertool></Playertool>*/}
        </>
    )
}
